import { Grid, Container, Paper } from "@mantine/core";
import CategoryBox from "../../components/common/categorybox";
import { useParams } from 'react-router-dom'; 
const SiteCategory = () => {

  const category = [
    {
      category: 'manuals',
      name: 'O & M Manuals'
    },
    {
      category: 'drawings',
      name: 'Drawings'
    },
    {
      category: 'changerequests',
      name: 'Change Request Form'
    }];
    const { siteId} = useParams();
  return <Container style={{ maxWidth: 780, paddingTop: '14rem' , }}>
      <Grid gutter={{ base: 5, xs: 'md', md: 'xl', xl: 50 }}>
        {category.map((el, idx) => {
          return <Grid.Col span={{ sm: 6, md: 4 }} ><CategoryBox from={''} siteId ={siteId} data={el} showActionMenu={false}/></Grid.Col>
        })}
      </Grid>
    </Container>
}

export default SiteCategory;
